/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CapabilityType } from './capabilityType';
import { AssessmentResult } from './assessmentResult';


export interface ExpiringAssessiblesItemsApiModel { 
    capabilityDefinitionsId: number;
    assessedItemId?: number | null;
    itemType: CapabilityType;
    name: string;
    validTo?: string | null;
    pending: boolean;
    category?: number | null;
    occupationId?: number | null;
    eligibility?: AssessmentResult | null;
    isMandatory: boolean;
}
export namespace ExpiringAssessiblesItemsApiModel {
}


